export default {
  id: 1,
  title: 'Target #1 - Simply Square',
  url: 'https://cssbattle.dev/play/1',
  colors: ['#5d3a3a', '#b5e0ba'],
  solution:
    '<p><style>body{background:#5d3a3a;margin:0}p{width:200;height:200;background:#b5e0ba}</style>',
}
